import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { mappingResultError, Result, UseCase } from '@digibricks/core';
import { FileStatus } from '../../..';
export var DELETE_QUESTION_FILE_USE_CASE = 'DELETE_QUESTION_FILE_USE_CASE';
export var DeleteQuestionFileUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(DeleteQuestionFileUseCase, _UseCase);

  var _super = _createSuper(DeleteQuestionFileUseCase);

  function DeleteQuestionFileUseCase() {
    _classCallCheck(this, DeleteQuestionFileUseCase);

    return _super.apply(this, arguments);
  }

  _createClass(DeleteQuestionFileUseCase, [{
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(useCaseInput) {
        var id, currentQuestion, status, deletedResult;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                id = useCaseInput.id, currentQuestion = useCaseInput.currentQuestion, status = useCaseInput.status;

                if (!(status === FileStatus.Uploaded)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", Result.ok(currentQuestion));

              case 3:
                deletedResult = currentQuestion.deleteFile(id);

                if (!deletedResult.isFailure) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", mappingResultError(deletedResult));

              case 6:
                return _context.abrupt("return", Result.ok(currentQuestion));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return DeleteQuestionFileUseCase;
}(UseCase);